import {
  BrandPage,
  getStaticPaths,
  getStaticProps,
} from '@public/CmsPage/ShowroomPage/BrandPage'

export { getStaticPaths, getStaticProps }

export default BrandPage
